module.exports = __webpack_public_path__ + "static/media/scandui.f1ca4a24.png";